import { observer } from 'mobx-react-lite';
import { Button, Header, Segment, Form } from 'semantic-ui-react';
import * as Yup from 'yup';
import { Formik } from 'formik';
import MyTextInput from '../../app/common/form/MyTextInput';
import { store, useStore } from '../../app/stores/store';
import { v4 as uuid } from 'uuid';
import { Customer, CustomerInitialData } from '../../app/models/customer';
import { currencyOptions } from './../../app/common/options/countrystateOptions/currencyOptions';
import { userLanguage } from '../../app/common/userLanguageSchema/userLanguage';
import { useEffect, useState } from 'react';
import '../../app/common/MediaQuery/responsive-forms.css';
import MySelectInput from '../../app/common/form/MySelectInput';
import sendRespectiveEmail from '../../app/models/EmailNew';
import UnauthorizedMessage from '../UnauthorizedMessage';
import LoadingComponent from '../../app/layout/LoadingComponent';

function CustomerMasterForm() {
  const {
    customerStore,
    userStore,
    modalStore,
    RolesAndPermissionsIDStore,
    dashboardStore,
    commonStore,
  } = useStore();
  const { createCustomer, selectedCustomer, updateCustomer } = customerStore;
  const [customerData, setCustomerData] =
    useState<Customer>(CustomerInitialData);

  useEffect(() => {
    // updating
    if (
      selectedCustomer?.id !== undefined &&
      dashboardStore.dashboard.formikClearFormBool === true
    ) {
      const newArr = {
        ...selectedCustomer,
      };
      setCustomerData(newArr);
    }
    // eslint-disable-next-line
  }, [selectedCustomer]);
  ////////////////////////////// Form Submit
  const handleSubmit = (values: Customer) => {
    if (values.id === '') {
      // Customer id is null for creating Customer
      const ID = uuid();
      const newcustomerData = {
        ...values,
        id: ID,
      };
      const newRoleArr = {
        id: uuid(),
        itemId: ID,
        rolesId:
          userStore.user?.roleId !== undefined ? userStore.user?.roleId : '',
      };

      createCustomer(newcustomerData); //create  data   api
      sendRespectiveEmail(
        'created',
        newcustomerData.customer_Name,
        'Created Customer',
        '',
      );
      dashboardStore.dashboard.formikClearFormBool = false; //resetting data
      store.customerStore.selectedCustomer = undefined; //resetting data
      RolesAndPermissionsIDStore.createRoleID(newRoleArr); //for roles and permissions
    } else {
      updateCustomer(values); //update  data   api
      sendRespectiveEmail(
        'edited',
        values.customer_Name,
        'Edited Customer',
        '',
      );
      dashboardStore.dashboard.formikClearFormBool = false; //resetting data
      store.customerStore.selectedCustomer = undefined; //resetting data
    }
    modalStore.closeModal(); //closing modal
    setCustomerData(CustomerInitialData); //resetting data
  };
  ////////////////////handle Change
  const handleChange = (e: any) => {
    const newArr = {
      ...customerData,
      [e.target.name]: e.target.value,
    };
    setCustomerData(newArr);
  };

  ////////////////////handle Cancel
  const handleCancel = () => {
    setCustomerData(CustomerInitialData); //resetting data
    modalStore.closeModal(); //closing modal
    dashboardStore.dashboard.formikClearFormBool = false; //resetting data
    store.customerStore.selectedCustomer = undefined; //resetting data
  };

  return (
    <div id="parent-grid-vault" className="largeScreen smallScreen">
      {dashboardStore.dashboard.loadingdata === 'loading' && (
        <LoadingComponent />
      )}

      {dashboardStore.dashboard.loadingdata !== 'loading' &&
        !userStore.user?.isAdmin === true && <UnauthorizedMessage />}

      {dashboardStore.dashboard.loadingdata !== 'loading' &&
        userStore.user?.isAdmin === true && (
          <Segment clearing className="vault-form-segment" responsive={true}>
            <Header
              icon="edit"
              size="huge"
              dividing
              as="h1"
              content={
                (
                  userLanguage[0].CUSTOMERMASTERRegisterCustomer?.CMRL01 as any
                )?.[`${commonStore.language.key}`]
              } //'Customer Master'
              sub
              color="grey"
            />
            <Formik
              initialValues={customerData}
              enableReinitialize={true}
              onSubmit={(values, { resetForm }) => {
                handleSubmit(values);
                resetForm();
              }}
              validationSchema={Yup.object({
                customer_Name: Yup.string()
                  .min(1)
                  .max(70)
                  .required('Please enter a name')
                  .matches(
                    /^[aA-zZ\s]+$/,
                    'Only alphabets are allowed for this field ',
                  ),
                customer_Currency: Yup.string().required(
                  'Please specify a currency',
                ),
                customer_Email: Yup.string()
                  .email('Invalid email format')
                  .required('Please enter a email'),
                customer_Phone_Number: Yup.string()
                  .min(9)
                  .max(16)
                  .required('Please Enter Valid Number'),
                customer_Address: Yup.string()
                  .min(2)
                  .max(150)
                  .required('Please enter address'),
              })}
            >
              {({ handleSubmit, isSubmitting }) => (
                <Form
                  className="ui form error"
                  onSubmit={handleSubmit}
                  autoComplete="off"
                >
                  <Form.Group widths="equal">
                    <MyTextInput
                      value={customerData.customer_Name}
                      onChange={(e: any) => handleChange(e)}
                      name="customer_Name"
                      label={
                        (
                          userLanguage[0].CUSTOMERMASTERRegisterCustomer
                            .CMRL02 as any
                        )?.[`${commonStore.language.key}`]
                      } //'Full Name'
                      placeholder={
                        (
                          userLanguage[0].CUSTOMERMASTERRegisterCustomer
                            .CMRTB01 as any
                        )?.[`${commonStore.language.key}`]
                      } //'Full Name'
                    />
                    <MySelectInput
                      name="customer_Currency"
                      label={
                        (
                          userLanguage[0].CUSTOMERMASTERRegisterCustomer
                            .CMRL03 as any
                        )?.[`${commonStore.language.key}`]
                      }
                      options={currencyOptions}
                      placeholder={
                        (
                          userLanguage[0].CUSTOMERMASTERRegisterCustomer
                            .CMRTB02 as any
                        )?.[`${commonStore.language.key}`]
                      } //'Currency '
                    />
                    {/* <label style={{color:"black"}}>Currency</label>
                                <Dropdown fluid selection value={customerData.customer_Currency}  onChange={(e:SyntheticEvent,data:any)=>handleCurrency(e,data)}name='customer_Currency' placeholder='Currency ' label={userLanguage[0].CUSTOMERMASTERRegisterCustomer.CMRL03 as any)?.[`${commonStore.language.key}`]} options={currencyOptions}  />      */}
                    <MyTextInput
                      value={customerData.customer_Email}
                      onChange={(e: any) => handleChange(e)}
                      name="customer_Email"
                      label={
                        (
                          userLanguage[0].CUSTOMERMASTERRegisterCustomer
                            ?.CMRL04 as any
                        )?.[`${commonStore.language.key}`]
                      } //'Email'
                      placeholder={
                        (
                          userLanguage[0].CUSTOMERMASTERRegisterCustomer
                            ?.CMRTB03 as any
                        )?.[`${commonStore.language.key}`]
                      } //'Email'
                    />
                  </Form.Group>
                  <Form.Group widths="equal">
                    <MyTextInput
                      value={customerData.customer_Address}
                      onChange={(e: any) => handleChange(e)}
                      name="customer_Address"
                      label={
                        (
                          userLanguage[0].CUSTOMERMASTERRegisterCustomer
                            .CMRL05 as any
                        )?.[`${commonStore.language.key}`]
                      } //'Address'
                      placeholder={
                        (
                          userLanguage[0].CUSTOMERMASTERRegisterCustomer
                            ?.CMRTB04 as any
                        )?.[`${commonStore.language.key}`]
                      } //'Address'
                    />
                    <MyTextInput
                      value={customerData.customer_Phone_Number}
                      onChange={(e: any) => handleChange(e)}
                      name="customer_Phone_Number"
                      type="number"
                      label={
                        (
                          userLanguage[0].CUSTOMERMASTERRegisterCustomer
                            .CMRL06 as any
                        )?.[`${commonStore.language.key}`]
                      } //'Phone Number'
                      placeholder={
                        (
                          userLanguage[0].CUSTOMERMASTERRegisterCustomer
                            .CMRTB05 as any
                        )?.[`${commonStore.language.key}`]
                      } //'Phone Number'
                    />
                  </Form.Group>
                  <Button.Group floated="right" style={{ marginTop: '40px' }}>
                    <Button
                      onClick={handleCancel}
                      type="reset"
                      //Cancel
                    >
                      {' '}
                      {
                        (
                          userLanguage[0].CUSTOMERMASTERRegisterCustomer
                            ?.CMRB01 as any
                        )?.[`${commonStore.language.key}`]
                      }
                    </Button>
                    <Button.Or
                      text={
                        (
                          userLanguage[0].CUSTOMERMASTERRegisterCustomer
                            ?.CMRB02 as any
                        )?.[`${commonStore.language.key}`]
                      }
                    />
                    <Button
                      loading={isSubmitting}
                      type="submit"
                      content="Submit"
                      positive
                    >
                      {
                        (
                          userLanguage[0].CUSTOMERMASTERRegisterCustomer
                            ?.CMRB03 as any
                        )?.[`${commonStore.language.key}`]
                      }
                    </Button>
                  </Button.Group>
                </Form>
              )}
            </Formik>
          </Segment>
        )}
    </div>
  );
}
export default observer(CustomerMasterForm);
